// Module
var code = "<div> <section class=\"heading\"> <div class=\"row no-gutter\"> <ng-include src=\"'/dashboard/nav.html'\"></ng-include> </div> </section> <orders-dashboard current-user=\"currentUser\" on-error=\"onError\"/> </div> ";
// Exports
var _module_exports = code;;
var path = '/dashboard/orders.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;